export const NAME = 'CONSULTATION';

export const getConsultationBookings = (store) => store[NAME].bookings || [];
